/**
 * Labstep
 *
 * @module components/SecurityLog/Manager
 */

import { EntitySearchContainer as EntitySearchCursor } from 'labstep-web/components/Entity/Search/Cursor';
import { SecurityLogTable } from 'labstep-web/components/SecurityLog/Table';
import { Log } from 'labstep-web/models/log.model';
import type React from 'react';
import type { ISecurityLogManagerProps } from './types';

export const SecurityLogManager: React.FC<
  ISecurityLogManagerProps
> = ({ organization }) => (
  <EntitySearchCursor
    entityName={Log.entityName}
    params={{
      organization_id: organization.id,
      count: 10,
      action: 'security',
      has_request_trace: true,
      skip_total: true,
    }}
    hideFilters
  >
    {({ entities }) => (
      <SecurityLogTable securityLogs={entities as Log[]} />
    )}
  </EntitySearchCursor>
);
